<template>
  <div class="column">
    <!-- <h3 class="mb-3">{{$store.state.user.langEng ? 'Important' : 'Viktigt'}}</h3> -->
  </div>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import RightPanel from './RightPanel'

@Component({
  extends: RightPanel
})
export default class Notifications extends Vue { }
</script>

<style scoped lang="scss">
h3 {
  width: 100%;
  text-align: end;
  border-bottom: solid 1px darkgray;
}
</style>
